import { Tabs, TabsList, TabsTrigger, TabsContent } from '@neo/primitives/tabs'
import { RefreshCw } from 'lucide-react'
import { Button } from '@neo/index'
import { conversationQueryKeys, getSettingsQueryKeys } from 'v2/shared/utils/query-key-management'
import { queryClient } from 'v2/configs/rq-setup'
import { ConvChannels } from 'v2/types/api/conversations'
import { useState } from 'react'
import { cn } from '@neo/lib/utils'
import { AgentList } from './agent-list'
import { TeamList } from './team-list'
import { InternalContactsList } from './internal-contacts-list'
import type { TransferTabsProps } from './types'

export const TransferTabs = ({ channel, onTransferSuccess }: TransferTabsProps) => {
  const [isRefreshing, setIsRefreshing] = useState(false)
  return (
    <Tabs defaultValue="agent" className="overflow-hidden">
      <TabsList className="w-full" variant="simple">
        <TabsTrigger value="agent" data-testid="tab-agent">
          Agent
        </TabsTrigger>
        <TabsTrigger value="team" data-testid="tab-team">
          Team
        </TabsTrigger>
        {channel === ConvChannels.CALL && (
          <TabsTrigger value="internal" data-testid="tab-internal">
            Contacts
          </TabsTrigger>
        )}

        <Button
          variant="ghost"
          size="iconSm"
          className="ml-auto"
          type="button"
          onClick={() => {
            setIsRefreshing(true)
            queryClient.invalidateQueries({ queryKey: conversationQueryKeys().liveAgents(channel) })
            queryClient.invalidateQueries({ queryKey: conversationQueryKeys().liveTeams(channel) })
            queryClient.invalidateQueries({ queryKey: getSettingsQueryKeys().internalNumbers })
            setTimeout(() => {
              setIsRefreshing(false)
            }, 2000)
          }}
          data-testid="button-refresh-transfer-lists"
        >
          <RefreshCw className={cn('h-4 w-4', isRefreshing && 'animate-spin')} />
        </Button>
      </TabsList>
      <div className="mt-4">
        <TabsContent value="agent">
          <AgentList channel={channel} onTransferSuccess={onTransferSuccess} />
        </TabsContent>
        <TabsContent value="team">
          <TeamList channel={channel} onTransferSuccess={onTransferSuccess} />
        </TabsContent>
        {channel === ConvChannels.CALL && (
          <TabsContent value="internal">
            <InternalContactsList channel={channel} onTransferSuccess={onTransferSuccess} />
          </TabsContent>
        )}
      </div>
    </Tabs>
  )
}
